import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import WorkspaceSidebar from '@/components/WorkspaceSidebar';
import CommandSearch from '@/components/CommandSearch';

// App-style shell for the logged-in business area: sticky sidebar + content
export default function WorkspaceShell({ user, children }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('tm_ws_collapsed') === '1');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { localStorage.setItem('tm_ws_collapsed', collapsed ? '1' : '0'); }, [collapsed]);
  useEffect(() => { setMobileOpen(false); }, [pathname]);
  useEffect(() => {
    const onKey = (e) => { if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); setSearchOpen((o) => !o); } };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="flex min-h-[calc(100vh-4rem)]" data-testid="ws-shell">
      <div className="hidden lg:block sticky top-16 h-[calc(100vh-4rem)] shrink-0">
        <WorkspaceSidebar user={user} collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} onSearch={() => setSearchOpen(true)} />
      </div>
      {mobileOpen && (
        <div className="lg:hidden fixed inset-0 z-[70]" data-testid="ws-mobile-drawer">
          <div className="absolute inset-0 bg-slate-900/50" onClick={() => setMobileOpen(false)} />
          <div className="absolute left-0 top-0 bottom-0 shadow-2xl">
            <WorkspaceSidebar user={user} collapsed={false} onSearch={() => { setMobileOpen(false); setSearchOpen(true); }} onNavigate={() => setMobileOpen(false)} />
          </div>
          <button type="button" onClick={() => setMobileOpen(false)} className="absolute top-3 left-[17rem] text-white" aria-label="Close menu"><X /></button>
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-16 z-40 bg-white/95 backdrop-blur border-b border-slate-200 px-4 py-2 flex items-center gap-3">
          <button type="button" onClick={() => setMobileOpen(true)} data-testid="ws-mobile-menu-btn" className="flex items-center gap-2 text-sm font-semibold text-slate-700">
            <Menu size={18} /> Workspace menu
          </button>
          <button type="button" onClick={() => setSearchOpen(true)} data-testid="ws-mobile-search-btn" className="ml-auto text-sm text-slate-500">Search</button>
        </div>
        {children}
      </div>
      <CommandSearch open={searchOpen} onOpenChange={setSearchOpen} />
    </div>
  );
}
